import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-select-certificate-type-modal',
    templateUrl: './select-certificate-type-modal.component.html',
    styleUrl: './select-certificate-type-modal.component.css',
    standalone: false
})

export class SelectCertificateTypeModalComponent {
  selectedType: 'token' | 'pkcs10' | null = null;

  constructor(public dialogRef: MatDialogRef<SelectCertificateTypeModalComponent>) {}

  selectType(type: 'token' | 'pkcs10'): void {
    this.selectedType = type;
  }

  proceed(): void {
    if (this.selectedType) {
      this.dialogRef.close(this.selectedType);
    }
  }

  cancel(): void {
    this.dialogRef.close(null);
  }
}